const contact = {
    email: "mailto: doali246885@gmail.com",
    linkedin: "https://www.linkedin.com/in/doaa-ali-el-sayed-8097a3262/",
    github: "https://github.com/doaaAli11",
    behance: "https://www.behance.net/doaaali816",
    telegram: "https://t.me/DoaaAli846",
    whatsapp: "https://wa.me/+201019271286",
    facebook: "https://www.facebook.com/DoaaAli72",
    khamsat: "https://khamsat.com/user/doaa_ali_168",
    mostaql: "https://mostaql.com/u/Doaa_Ali168",
    freelancer: "https://www.freelancer.com/u/doaa168",

};

export const getContactInfo = () => {
    return contact;
};
